<template>
  <div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Auth0Callback',
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  methods: {
    ...mapMutations('auth', ['SET_USER']),
  },
  async mounted() {
    await this.$store.dispatch('auth/handleAuthentication').catch(() => {
      this.$router.push({ name: 'login' });
    });
    if (this.isLoggedIn) {
      this.$router.push({ name: 'index' });
    } else {
      this.$router.push({ name: 'login' });
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
